$.fn.isVisible = function(node) {
    var rect = node.getBoundingClientRect();
    return (
        (rect.height > 0 || rect.width > 0) &&
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    )
};

$(document).ready(function() {

    // Parallax

    $(window).scroll(function() {
        var scrolled = $(window).scrollTop()
        $('[data-parallax="scroll"]').each(function(index, element) {
            var initY = $(this).offset().top
            var height = $(this).height()
            var parallax = $(this).data('parallax-offset');
            var endY  = initY + $(this).height()
            // Check if the element is in the viewport.
            var visible = $().isVisible(this);
            if(visible) {
                var diff = scrolled - initY
                var ratio = Math.round((diff / height) * 100)
                $(this).css('background-position','center ' + parseInt(-(ratio * parallax)) + 'px')
            }
        });

    });



});


